<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div
        class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
      >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Empresa/Institución</label>
                <select
                  v-model="filters.companyId"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsCompany"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Torneo</label>
                <!-- <v-select
                  v-if="itemsTournament && itemsTournament.length > 0"
                  v-model="filters.tournamentIds"
                  :options="
                    itemsTournament.map((t) => ({ label: t.name, value: t.id }))
                  "
                  :multiple="true"
                  placeholder="-- TODOS --"
                /> -->
                <Multiselect
                  v-model="filters.tournamentIds"
                  mode="tags"
                  placeholder="-- TODOS --"
                  :options="
                    itemsTournament.map((t) => ({ value: t.id, label: t.name }))
                  "
                />
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Nombre</label>
                <input
                  type="text"
                  v-model.trim="filters.name"
                  class="form-control h-55"
                  placeholder="Ingrese nombre"
                />
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Estado Registro</label>
                <select
                  v-model="filters.isActive"
                  class="form-select form-control h-55"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option value="true">{{ STATUS.ACTIVE }}</option>
                  <option value="false">{{ STATUS.INACTIVE }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6 text-end mt-4">
              <div class="d-inline-flex flex-wrap gap-2 justify-content-end">
                <button
                  type="button"
                  @click.prevent="
                    currentPage = 1;
                    getTeams(currentPage);
                  "
                  class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                >
                  Buscar
                </button>
                <button
                  type="button"
                  @click.prevent="exportToExcel"
                  class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                  :disabled="isLoading"
                >
                  {{ isLoading ? "Exportando..." : "Exportar" }}
                </button>
                <RouterLink to="/team/create">
                  <button
                    type="button"
                    class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                  >
                    <span class="py-sm-1 d-block">
                      <span>Agregar Equipo</span>
                    </span>
                  </button>
                </RouterLink>
                <div class="dropdown">
                  <button
                    id="dropdownCargaMasiva"
                    class="btn btn-primary text-white py-2 dropdown-toggle"
                    type="button"
                    @click="toggleDropdown"
                    aria-expanded="false"
                  >
                    <span class="py-sm-1"> Carga masiva </span>
                  </button>
                  <ul class="dropdown-menu bg-primary">
                    <li>
                      <a
                        class="dropdown-item text-white"
                        href="#"
                        @click.prevent="bulkloadTeamsModal"
                        >Equipos</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item text-white"
                        href="#"
                        @click.prevent="bulkloadTeamPlayersModal"
                        >Jugadores x Equipos</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" class="text-center">Empresa/Institución</th>
                <th scope="col" class="text-center">Torneos</th>
                <th scope="col" class="text-center">Equipo</th>
                <th scope="col" class="text-center">Nro. <br />Jugadores</th>
                <th scope="col" class="text-center">Estado Registro</th>
                <th scope="col" class="text-center">
                  Creado<br />
                  por
                </th>
                <th scope="col" class="text-center">Fecha <br />creación</th>
                <th scope="col" class="text-center">Modificado <br />por</th>
                <th scope="col" class="text-center">
                  Fecha <br />
                  modificación
                </th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 + (currentPage - 1) * pageSize }}
                </td>
                <td class="text-body">{{ item.company.name }}</td>
                <td class="text-body">{{ item.tournament.name }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.numberPlayers }}</td>
                <td class="text-body text-center">
                  <span
                    @click="confirmChangeStatus(item.id, item.isActive)"
                    class="badge bg-opacity-10 p-2 fs-12 fw-normal"
                    role="button"
                    :class="computeStatusClass(item.isActive)"
                  >
                    {{ item.isActive ? STATUS.ACTIVE : STATUS.INACTIVE }}
                  </span>
                </td>
                <td class="text-body">{{ item.createdBy }}</td>
                <td class="text-body">{{ item.createdAtDateTimeString }}</td>
                <td class="text-body">{{ item.updatedBy }}</td>
                <td class="text-body">{{ item.updatedAtDateTimeString }}</td>
                <td class="text-center">
                  <div class="">
                    <RouterLink :to="`/team/edit/${item.id}`">
                      <i class="material-symbols-outlined fs-16 text-primary">
                        edit
                      </i>
                    </RouterLink>
                    <button
                      class="ps-2 border-0 bg-transparent lh-1 position-relative"
                      @click="
                        teamPlayersModal(item.id, item.id)
                      "
                    >
                      <i class="material-symbols-outlined fs-16 text-primary">
                        sports_kabaddi
                      </i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="p-4 pt-lg-4">
          <Pagination
            :currentPage="currentPage"
            :pageSize="pageSize"
            :totalItems="totalItems"
            @update:page="fetchPage"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- Modal Carga Masiva Equipos-->
  <div
    id="mdlBulkloadTeams"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlBulkloadTeamsLabel"
    aria-hidden="true"
    size="large"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlBulkloadTeamsLabel">
            Carga Masiva de Equipos
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-6 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Torneo</label>
                <select
                  v-model="formBulkloadTeams.tournamentId"
                  @change="clearError('tournamentId')"
                  class="form-select form-control h-45"
                  aria-label="Default select example"
                >
                  <option :value="null">-- Seleccionar --</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsTournament"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>

                <div v-if="errors.tournamentId" class="input-error">
                  {{ errors.tournamentId }}
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6">
              <div class="form-group mb-4">
                <label>
                  <a @click="downloadFile()" class="col-md-8">
                    <u class="text-primary" style="cursor: pointer"
                      >Descargar Plantilla</u
                    >
                  </a>
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Archivo</label>
                <FilePond
                  name="teamDataFile"
                  :maxFileSize="'20MB'"
                  :accepted-file-types="supportedFormats"
                  allow-multiple="false"
                  :max-files="1"
                  label-idle="Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>"
                  :labelMaxFileSizeExceeded="'El archivo es demasiado grande'"
                  :labelMaxFileSize="'El tamaño máximo permitido es {filesize}'"
                  :labelFileTypeNotAllowed="'El archivo tiene una extensión no permitida'"
                  :fileValidateTypeLabelExpectedTypes="`El tipo de archivo permitido es: .xlsx`"
                  credits=""
                  @updatefiles="handleUpdateFiles"
                  @input="clearError('teamDataFile')"
                />
                <div v-if="errors.teamDataFile" class="input-error">
                  {{ errors.teamDataFile }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary text-white"
            @click="validateForm"
          >
            Guardar
          </button>
          <button
            type="button"
            class="btn btn-danger text-white"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Carga Masiva Jugadores -->
  <div
    id="mdlBulkloadTeamPlayers"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlBulkloadTeamPlayersLabel"
    aria-hidden="true"
    size="large"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlBulkloadTeamPlayersLabel">
            Carga Masiva de Jugadores por Equipos
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-6 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Archivo</label>
                <FilePond
                  name="teamDataFile"
                  :maxFileSize="'20MB'"
                  :accepted-file-types="supportedFormats"
                  allow-multiple="false"
                  :max-files="1"
                  label-idle="Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>"
                  :labelMaxFileSizeExceeded="'El archivo es demasiado grande'"
                  :labelMaxFileSize="'El tamaño máximo permitido es {filesize}'"
                  :labelFileTypeNotAllowed="'El archivo tiene una extensión no permitida'"
                  :fileValidateTypeLabelExpectedTypes="`El tipo de archivo permitido es: .xlsx`"
                  credits=""
                  @updatefiles="handleUpdateFilesBulkloadTeamPlayers"
                  @input="clearErrorBulkloadTeamPlayers('teamDataFile')"
                />
                <div
                  v-if="errorsBulkloadTeamPlayers.teamDataFile"
                  class="input-error"
                >
                  {{ errorsBulkloadTeamPlayers.teamDataFile }}
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6">
              <div class="form-group mb-4">
                <label>
                  <a
                    @click="downloadFileBulkloadTeamPlayers()"
                    class="col-md-8"
                  >
                    <u class="text-primary" style="cursor: pointer"
                      >Descargar Plantilla</u
                    >
                  </a>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary text-white"
            @click="validateFormBulkloadTeamPlayers"
          >
            Guardar
          </button>
          <button
            type="button"
            class="btn btn-danger text-white"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Jugadores Equipo-->
  <div
    id="mdlJugadores"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlJugadoresLabel"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    size="large"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlJugadoresLabel">
            Equipo {{ teamEdit.name }} - Jugadores
          </h1>
          <button
            type="button"
            class="btn-close"
            @click="closeModal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="position-relative mb-3">
            <input
              v-model="searchQuery"
              @input="fetchResults"
              type="text"
              class="form-control"
              placeholder="Escribe para buscar jugadores..."
            />

            <ul
              v-if="showDropdown && results.length"
              class="dropdown-menu show w-100 mt-1"
            >
              <li
                v-for="item in results"
                :key="item.id"
                class="dropdown-item"
                @click="selectItem(item)"
              >
                {{ item.fullName }}
              </li>
            </ul>
          </div>
          <div class="default-table-area style-two default-table-width">
            <div class="table-responsive">
              <table class="table align-middle">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col" class="text-center">Nombres</th>
                    <th scope="col" class="text-center">Apellidos</th>
                    <th scope="col" class="text-center">Alias</th>
                    <th scope="col" class="text-center">Capitán</th>
                    <th scope="col" class="text-center"></th>
                    <th scope="col" class="text-center">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in teamPlayers" :key="item.id">
                    <td>
                      {{ index + 1 }}
                    </td>
                    <td>{{ item.firstName }}</td>
                    <td>{{ item.lastName }}</td>
                    <td>{{ item.alias }}</td>
                    <td class="text-center">
                      {{ item.isCaptainStr }}
                    </td>
                    <td>
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="flexSwitchCheckDefault"
                          v-model="item.isCaptain"
                          @change="
                            confirmChangeCaptain(item.id, item.isCaptain)
                          "
                        />
                        <label
                          class="form-check-label"
                          for="flexSwitchCheckDefault"
                        ></label>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="">
                        <button
                          class="ps-2 border-0 bg-transparent lh-1 position-relative"
                          @click="deletePlayerTeam(item.id)"
                        >
                          <i
                            class="material-symbols-outlined fs-16 text-primary"
                          >
                            delete
                          </i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger text-white"
            @click="closeModal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { teamBulkloadSchema } from "@/schemas/teamBulkloadSchema";
import { teamPlayersBulkloadSchema } from "@/schemas/teamPlayersBulkloadSchema";
import { defineComponent, ref, onMounted } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";
import api from "@/services/api";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css';
import {
  PAGINATION_ITEMS_PER_PAGE,
  STATUS,
  LABELS,
  COMPANY_TYPES,
  TEMPLATE_TYPES,
} from "@/utils/constants";

// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview
);
export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Teams",
  components: {
    Pagination,
    OverlayLoader,
    FilePond,
    Multiselect
  },
  setup() {
    const isLoading = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const toast = useToast();
    const flagChangePlayer = ref(false);

    const itemsCompany = ref<any[]>([]);
    const itemsTournament = ref<any[]>([]);
    const items = ref<any[]>([]);
    const filters = ref({
      name: "",
      tournamentIds: [],
      companyId: null,
      isActive: null,
    });
    const supportedFormats = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    const errors = ref<Record<string, string>>({});
    const formBulkloadTeams = ref({
      id: 0,
      tournamentId: null,
      teamDataFile: null,
    });
    const modalBulkloadTeams = ref<any>(null);

    const errorsBulkloadTeamPlayers = ref<Record<string, string>>({});
    const formBulkloadTeamPlayers = ref({
      id: 0,
      teamDataFile: null,
    });
    const modalBulkloadTeamPlayers = ref<any>(null);

    const modalTeamPlayers = ref<any>(null);
    const teamPlayers = ref<any[]>([]);
    const teamEdit = ref<any>({});

    const searchQuery = ref("");
    const searchTournamentId = ref(0);
    const searchTeamId = ref(0);

    const results = ref<any[]>([]);
    const showDropdown = ref(false);
    let timeout: number;

    onMounted(async () => {
      await getCompanies();
      await getTournaments();
      await getTeams(currentPage.value);
      await getBulkloadTeams();

      const modalElement = document.getElementById("mdlBulkloadTeams");
      if (modalElement) {
        modalBulkloadTeams.value = new window.bootstrap.Modal(modalElement);
        modalBulkloadTeams.value.hide();
      }

      const modalBulkloadTeamPlayersEl = document.getElementById(
        "mdlBulkloadTeamPlayers"
      );
      if (modalBulkloadTeamPlayersEl) {
        modalBulkloadTeamPlayers.value = new window.bootstrap.Modal(
          modalBulkloadTeamPlayersEl
        );
        modalBulkloadTeamPlayers.value.hide();
      }

      const mdlJugadores = document.getElementById("mdlJugadores");
      if (mdlJugadores && window.bootstrap) {
        modalTeamPlayers.value = new window.bootstrap.Modal(mdlJugadores);
        modalTeamPlayers.value.hide();
      }

      const el = document.getElementById("dropdownCargaMasiva");
      if (el && window.bootstrap?.Dropdown) {
        new window.bootstrap.Dropdown(el); // Optional if data-bs-toggle is used
      }
    });

    const computeStatusClass = (classValue: boolean) => {
      return {
        shipped: classValue,
        deactive: !classValue,
      };
    };

    const toggleDropdown = () => {
      const dropdownEl = document.getElementById("dropdownCargaMasiva");
      if (dropdownEl && window.bootstrap?.Dropdown) {
        const dropdown =
          window.bootstrap.Dropdown.getInstance(dropdownEl) ||
          new window.bootstrap.Dropdown(dropdownEl);
        dropdown.toggle();
      }
    };

    const hideDropdown = () => {
      const dropdownEl = document.getElementById("dropdownCargaMasiva");
      if (dropdownEl && window.bootstrap?.Dropdown) {
        const dropdown = window.bootstrap.Dropdown.getInstance(dropdownEl);
        if (dropdown) dropdown.hide();
      }
    };

    const getCompanies = async () => {
      try {
        const response = await api.get(
          `/common/companies?type=${COMPANY_TYPES.PARTICIPANTE}`
        );
        itemsCompany.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };
    const getTournaments = async () => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;

        const response = await api.get(`/tournament?${params}`);

        itemsTournament.value = response.data.list;
      } catch (error) {
        console.error(error);
      }
    };
    const getTeams = async (page: number) => {
      try {
        isLoading.value = true;
        var params = `pageNumber=${page}&pageSize=${pageSize.value}`;
        if (filters.value.name) {
          params = params + `&name=${filters.value.name}`;
        }
        if (
          filters.value.tournamentIds &&
          filters.value.tournamentIds.length > 0
        ) {
          filters.value.tournamentIds.forEach((id) => {
            params = params + `&tournamentIds=${id}`;
          });
        }
        if (filters.value.companyId) {
          params = params + `&companyId=${filters.value.companyId}`;
        }
        if (filters.value.isActive) {
          params = params + `&isActive=${filters.value.isActive}`;
        } 

        const response = await api.get(
          `/team?${params}`
        );
        items.value = response.data.list;
        totalItems.value = response.data.rows;
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    const fetchPage = async (page: number) => {
      currentPage.value = page;
      getTeams(currentPage.value);
    };

    const exportToExcel = async () => {
      try {
        isLoading.value = true;

        const params = new URLSearchParams();

        if (filters.value.name) params.append("name", filters.value.name);
        if (
          filters.value.tournamentIds &&
          Array.isArray(filters.value.tournamentIds) &&
          filters.value.tournamentIds.length > 0
        ) {
          filters.value.tournamentIds.forEach((id) => {
            params.append("tournamentIds", String(id));
          });
        }
        if (
          filters.value.companyId !== null &&
          filters.value.companyId !== undefined
        )
          params.append("companyId", String(filters.value.companyId));
        if (
          filters.value.isActive !== null &&
          filters.value.isActive !== undefined
        )
          params.append("isActive", String(filters.value.isActive));

        const response: any = await api.get(`/reports/teams_export?${params}`, {
          responseType: "blob",
        });

        const contentDisposition =
          response.headers["content-disposition"] ||
          response.headers["Content-Disposition"];
        let fileName = "equipos.xlsx";

        if (contentDisposition) {
          let utf8FilenameRegex = /filename\*\s*=\s*UTF-8''([^;\n]*)/i;
          let matches = utf8FilenameRegex.exec(contentDisposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          } else {
            let simpleFilenameRegex = /filename\s*=\s*([^;\n]*)/i;
            matches = simpleFilenameRegex.exec(contentDisposition);
            if (matches && matches[1]) {
              fileName = matches[1].replace(/['"]/g, "");
            }
          }
        }

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();

        toast.success("Reporte exportado exitosamente", { timeout: 2000 });
      } catch (error) {
        console.error("Error al exportar:", error);
        toast.error("Error al exportar el reporte. Intente nuevamente.", {
          timeout: 2000,
        });
      } finally {
        isLoading.value = false;
      }
    };

    const confirmChangeStatus = async (id: number, status: boolean) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>${
          status ? "desactivar" : "activar"
        }</b> el Equipo?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí, ${status ? "desactivar" : "activar"} `,
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        isLoading.value = true;

        var obj = {
          id: id,
          status: !status,
        };

        const response: any = await api.put(`/team`, obj);

        if (response != 0) {
          toast.success(
            `El Equipo fue ${status ? "desactivado" : "activado"} con éxito.`,
            {
              timeout: 2000,
            }
          );
          fetchPage(currentPage.value);
        } else {
          toast.error(
            `El Equipo no pudo ser ${status ? "desactivado" : "activado"}.`,
            {
              timeout: 2000,
            }
          );
        }
        isLoading.value = false;
      }
    };
    const confirmChangeCaptain = async (
      playerId: number,
      isCaptain: boolean
    ) => {
      isLoading.value = true;

      var obj = {
        id: searchTeamId.value,
        playerId: isCaptain == false ? 0 : playerId,
      };

      const response: any = await api.put(`/team/update-captain`, obj);

      if (response != 0) {
        toast.success(`El registro fue actualizado con éxito.`, {
          timeout: 2000,
        });
        getTeamPlayers(teamEdit.value.id);
      } else {
        toast.error(`Error al actualizar el registro.`, {
          timeout: 2000,
        });
      }
      isLoading.value = false;
    };

    const handleUpdateFiles = (fileItems: any[]) => {
      formBulkloadTeams.value.teamDataFile = fileItems.length
        ? fileItems[0].file
        : null;
    };

    const buildFormData = (data: any) => {
      const formData = new FormData();
      for (const key in data) {
        if (
          data[key] !== undefined &&
          data[key] !== null &&
          key != "createdBy"
        ) {
          formData.append(key, data[key]);
        }
      }
      return formData;
    };

    const resetFilePond = () => {
      const removeBtn = document.querySelector(
        ".filepond--file-action-button.filepond--action-remove-item"
      );
      if (removeBtn) {
        (removeBtn as HTMLElement).click();
      }
    };

    const bulkloadTeamsModal = async () => {
      try {
        hideDropdown();
        errorsBulkloadTeamPlayers.value = {};
        resetFilePond();
        formBulkloadTeams.value.teamDataFile = null;
        formBulkloadTeams.value.tournamentId = null;
        modalBulkloadTeams.value.show();
      } catch (ex) {
        console.error(ex);
      }
    };

    const createBulkloadTeams = async () => {
      try {
        const payload = {
          ...formBulkloadTeams.value,
        };

        const formData = buildFormData(payload);

        const response: any = await api.postForm(
          `team/bulkload-teams`,
          formData,
          { responseType: "blob" }
        );

        const contentType = response.headers["content-type"];
        if (contentType.includes("application/json")) {
          const data = await response.data.text();
          const json = JSON.parse(data);

          if (json.return) {
            toast.success(`La carga se realizó con éxito.`, { timeout: 2000 });
            resetFilePond();
            formBulkloadTeams.value.teamDataFile = null;
            formBulkloadTeams.value.tournamentId = null;
          } else {
            toast.error(json.message ?? "Error en la carga", { timeout: 2000 });
          }
        } else if (
          contentType.includes(
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          )
        ) {
          resetFilePond();
          formBulkloadTeams.value.teamDataFile = null;
          formBulkloadTeams.value.tournamentId = null;
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "ErroresCargaMasivaEquipos.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();

          toast.error(
            "Algunas filas tienen errores, revisa el Excel descargado",
            {
              timeout: 3000,
            }
          );
        } else {
          toast.error("Tipo de respuesta no esperado", { timeout: 2000 });
        }
      } catch (ex) {
        const err = ex as any;
        if (err.response?.data instanceof Blob) {
          const texto = await err.response.data.text();
          toast.error(texto, { timeout: 2000 });
        } else {
          toast.error(err.response?.data ?? "Error desconocido", {
            timeout: 2000,
          });
        }
      }
    };

    const downloadFile = async () => {
      try {
        const response = await api.get(
          `/team/downloadFile?fileType=${TEMPLATE_TYPES.EQUIPOS}`,
          {
            responseType: "blob",
          }
        );
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "PlantillaTeams";
        link.click();
      } catch (error) {
        toast.error("Error al descargar el archivo.", {
          timeout: 2000,
        });
        console.error("Error al descargar el archivo", error);
      }
    };
    const validateForm = async () => {
      try {
        errors.value = {};
        await teamBulkloadSchema.validate(formBulkloadTeams.value, {
          abortEarly: false,
          context: { id: formBulkloadTeams.value.id },
        });
        isLoading.value = true;

        await createBulkloadTeams();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = "";
    };
    const getBulkloadTeams = async () => {
      formBulkloadTeams.value.tournamentId = null;
    };

    const bulkloadTeamPlayersModal = async () => {
      try {
        hideDropdown();
        errorsBulkloadTeamPlayers.value = {};
        resetFilePond();
        formBulkloadTeamPlayers.value.teamDataFile = null;
        modalBulkloadTeamPlayers.value.show();
      } catch (ex) {
        console.error(ex);
      }
    };

    const validateFormBulkloadTeamPlayers = async () => {
      try {
        errorsBulkloadTeamPlayers.value = {};
        await teamPlayersBulkloadSchema.validate(formBulkloadTeamPlayers.value, {
          abortEarly: false,
          context: { id: formBulkloadTeamPlayers.value.id },
        });
        isLoading.value = true;

        await createBulkloadTeamPlayers();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errorsBulkloadTeamPlayers.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const createBulkloadTeamPlayers = async () => {
      try {
        const payload = {
          ...formBulkloadTeamPlayers.value,
        };

        const formData = buildFormData(payload);

        const response: any = await api.postForm(
          `team/bulkload-teams-players`,
          formData,
          { responseType: "blob" }
        );

        const contentType = response.headers["content-type"];
        if (contentType.includes("application/json")) {
          const data = await response.data.text();
          const json = JSON.parse(data);

          if (json.return) {
            toast.success(`La carga se realizó con éxito.`, { timeout: 2000 });
            resetFilePond();
            formBulkloadTeamPlayers.value.teamDataFile = null;
          } else {
            toast.error(json.message ?? "Error en la carga", { timeout: 2000 });
          }
        } else if (
          contentType.includes(
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          )
        ) {
          resetFilePond();
          formBulkloadTeamPlayers.value.teamDataFile = null;
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "ErroresCargaMasivaJugadoresEquipos.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();

          toast.error(
            "Algunas filas tienen errores, revisa el Excel descargado",
            {
              timeout: 3000,
            }
          );
        } else {
          toast.error("Tipo de respuesta no esperado", { timeout: 2000 });
        }
      } catch (ex) {
        const err = ex as any;
        if (err.response?.data instanceof Blob) {
          const texto = await err.response.data.text();
          toast.error(texto, { timeout: 2000 });
        } else {
          toast.error(err.response?.data ?? "Error desconocido", {
            timeout: 2000,
          });
        }
      }
    };

    const clearErrorBulkloadTeamPlayers = (field: string) => {
      errorsBulkloadTeamPlayers.value[field] = "";
    };

   const handleUpdateFilesBulkloadTeamPlayers = (fileItems: any[]) => {
      formBulkloadTeamPlayers.value.teamDataFile = fileItems.length
        ? fileItems[0].file
        : null;
    };

    const downloadFileBulkloadTeamPlayers = async () => {
      try {
        const response = await api.get(
          `/team/downloadFile?fileType=${TEMPLATE_TYPES.EQUIPOS_JUGADORES}`,
          {
            responseType: "blob",
          }
        );
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "PlantillaTeamsPlayers";
        link.click();
      } catch (error) {
        toast.error("Error al descargar el archivo.", {
          timeout: 2000,
        });
        console.error("Error al descargar el archivo", error);
      }
    };

    const teamPlayersModal = async (
      idTeam: number,
      teamId: number
    ) => {
      flagChangePlayer.value = false;
      try {
        searchTeamId.value = teamId;
        getTeamPlayers(idTeam);
        teamEdit.value = items.value.find((t) => t.id == idTeam);
        modalTeamPlayers.value.show();
      } catch (ex) {
        console.error(ex);
      }
    };

    const getTeamPlayers = async (idTeam: number) => {
      try {
        isLoading.value = true;

        const response = await api.get(`/team/${idTeam}/players`);

        teamPlayers.value = response.data;
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    const deletePlayerTeam = async (idPlayer: number) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>eliminar</b> al Jugador del Equipo '${teamEdit.value.name}'?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí, eliminar`,
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        isLoading.value = true;

        var obj = {
          tournamentId: teamEdit.value.tournament.id,
          teamId: teamEdit.value.id,
          playerId: idPlayer,
        };

        const response: any = await api.delete(`/team-player`, { data: obj });

        if (response != 0) {
          flagChangePlayer.value = true;
          toast.success(`El Jugador fue eliminado del Equipo con éxito.`, {
            timeout: 2000,
          });
          getTeamPlayers(teamEdit.value.id);
        } else {
          toast.error(`El Jugador no pudo ser eliminado.`, {
            timeout: 2000,
          });
        }
        isLoading.value = false;
      }
    };

    const fetchResults = () => {
      clearTimeout(timeout);

      if (!searchQuery.value || searchQuery.value.length < 2) {
        results.value = [];
        showDropdown.value = false;
        return;
      }

      // Debounce: wait 300ms before firing
      timeout = window.setTimeout(async () => {
        try {
          const response = await api.get(`/player/search`, {
            params: {
              query: searchQuery.value,
              teamId: searchTeamId.value,
            },
          });

          results.value = response.data;
          showDropdown.value = true;
        } catch (error) {
          console.error("Error fetching data", error);
          showDropdown.value = false;
        }
      }, 300);
    };

    const selectItem = async (item: any) => {
      isLoading.value = true;
      var obj = {
        teamId: searchTeamId.value,
        playerId: item.id,
      };
      const response: any = await api.post(`/team-player/create`, obj);
      if (response.data != null) {
        if (response.data > 0) {
          flagChangePlayer.value = true;
          searchQuery.value = "";
          showDropdown.value = false;
          toast.success(`El Jugador ha sido agregado al equipo con éxito.`, {
            timeout: 2000,
          });
          getTeamPlayers(searchTeamId.value);
        } else if (response.data == -1) {
          toast.error(`El Jugador ya se encuentra agregado en el torneo.`, {
            timeout: 2000,
          });
        } else {
          toast.error(`El Jugador no pudo ser agregado.`, {
            timeout: 2000,
          });
        }
      } else {
        toast.error(`El Jugador no pudo ser agregado.`, {
          timeout: 2000,
        });
      }
      isLoading.value = false;
      showDropdown.value = false;
    };

    const closeModal = async () => {
      if (flagChangePlayer.value) {
        await getTeams(currentPage.value);
      }
      searchQuery.value = "";
      showDropdown.value = false;
      flagChangePlayer.value = false;
      modalTeamPlayers.value.hide();
    };
    return {
      items,
      itemsCompany,
      itemsTournament,
      currentPage,
      pageSize,
      totalItems,
      STATUS,
      LABELS,
      OverlayLoader,
      filters,
      isLoading,
      computeStatusClass,
      getTeams,
      fetchPage,
      exportToExcel,
      confirmChangeStatus,
      formBulkloadTeams,
      clearError,
      bulkloadTeamsModal,
      handleUpdateFiles,
      supportedFormats,
      createBulkloadTeams,
      downloadFile,
      errors,
      validateForm,
      teamPlayers,
      getTeamPlayers,
      teamPlayersModal,
      teamEdit,
      toggleDropdown,
      formBulkloadTeamPlayers,
      handleUpdateFilesBulkloadTeamPlayers,
      downloadFileBulkloadTeamPlayers,
      clearErrorBulkloadTeamPlayers,
      errorsBulkloadTeamPlayers,
      validateFormBulkloadTeamPlayers,
      bulkloadTeamPlayersModal,
      deletePlayerTeam,
      searchQuery,
      searchTournamentId,
      searchTeamId,
      results,
      showDropdown,
      fetchResults,
      selectItem,
      closeModal,
      flagChangePlayer,
      confirmChangeCaptain,
    };
  },
});
</script>
